import { useMutation, useQueryClient } from '@tanstack/react-query'
import { transferServices } from '../transferServices'

export const useCreateExternalWithdraw = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: transferServices.createExternalWithdraw,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wallet'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
    },
  })
}
